import { ItemTab } from "@saleor/changeOrderDomestic/views/ViewEditOrder/types";
import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      marginTop: "4rem"
    },
    tabB: {
      marginLeft: "-3rem"
    },
    active: {
      backgroundColor: theme.palette.info.main,
      "& .MuiTypography-root": {
        color: "#FFFFFF"
      }
    },
    notActive: {
      backgroundColor: theme.palette.grey[300],
      "& .MuiTypography-root": {
        color: theme.palette.grey[600]
      }
    },
    z0: {
      zIndex: 0
    },
    z1: {
      zIndex: 1
    },
    z2: {
      zIndex: 2
    },
    z3: {
      zIndex: 3
    },
    z4: {
      zIndex: 4
    },
    tabBox: {
      display: "flex"
    },
    boxTable: {
      border: `solid 1px #007E92`,
      overflowX: "auto",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      "& .MuiTable-root": {
        // borderCollapse: "collapse"
      },
      "& .MuiTableCell-root": {
        padding: "10px",
        height: "48px",
        border: `1px solid ${theme.palette.grey[300]}`,
        "&:first-child:not(.MuiTableCell-paddingCheckbox)": {
          padding: 8
        }
      },
      "& .MuiTableHead-root .MuiTableCell-head": {
        height: (props: any) => (props?.activeTab === ItemTab.tabA ? 30 : 48),
        padding: "3.4px 10px"
      }
    },
    topBox: {
      position: "relative",
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "-3rem",
      height: "3.2rem"
    },
    normalText: {
      fontWeight: "normal"
    },
    noBorder: {
      border: "0 !important"
    },
    noBorderLeft: {
      borderLeft: "0 !important"
    },
    noBorderRight: {
      borderRight: "0 !important"
    },
    cellFrezze1: {
      minWidth: 64,
      position: "sticky",
      left: 0,
      background: "inherit",
      zIndex: 1,
      "& svg": {
        width: 25
      },
      "&>div>div": {
        marginRight: "-1rem"
      }
    },
    cellFrezze2: {
      minWidth: 174,
      maxWidth: 174,
      position: "sticky",
      left: 64,
      background: "inherit",
      zIndex: 1
    },
    cellFrezze3: {
      minWidth: (props: any) => (props?.activeTab === ItemTab.tabC ? 224 : 348),
      position: "sticky",
      left: 238,
      background: "inherit",
      zIndex: 1
    },
    btnExternal: {
      height: 32,
      margin: "-3px -0.8px",
      minWidth: 32,
      width: 36,
      padding: 6
    },
    colA0: {
      minWidth: 112
    },
    colA1: {
      minWidth: 112
    },
    colA2: {
      minWidth: 140
    },
    colA3: {
      minWidth: 112
    },
    colA4: {
      minWidth: 72
    },
    colA5: {
      minWidth: 64
    },
    colA6: {
      minWidth: 72
    },
    colA7: {
      minWidth: 64
    },
    colA8: {
      minWidth: 72
    },
    colA9: {
      minWidth: 96
    },
    colA10: {
      minWidth: 120
    },
    colA11: {
      minWidth: 80
    },
    colA12: {
      minWidth: 136,
      textWrap: "nowrap",
      padding: "3.4px 7.4px !important"
    },
    colA13: {
      minWidth: 80
    },
    colA14: {
      minWidth: 88
    },
    colA15: {
      minWidth: 224
    },
    colA16: {
      minWidth: 112
    },
    colA17: {
      minWidth: 120
    },
    colA18: {
      minWidth: 144
    },
    colA19: {
      boxSizing: "content-box",
      textWrap: "nowrap",
      padding: "0px 4px 0px 5px !important",
      minWidth: 56
    },
    colA20: {
      boxSizing: "content-box",
      textWrap: "nowrap",
      padding: "0px 4px 0px 4px !important",
      minWidth: 56
    },
    colA21: {
      boxSizing: "content-box",
      textWrap: "nowrap",
      padding: "0px 5px 0px 4px !important",
      width: 80
    },
    colA22: {
      minWidth: 80
    },
    colA23: {
      minWidth: 64
    },
    colA24: {
      minWidth: 56
    },
    cellFlexCenter: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    cellSize13: {
      fontSize: "1.4rem"
    },
    cellUnlimited: {
      background: "#F2FAFB !important"
    },
    checkBoxDisabled: {
      margin: "2px 4px 2px -1px",
      background: theme.palette.grey[200]
    },
    colB1: {
      minWidth: 138
    },
    colB2: {
      minWidth: 138
    },
    colB3: {
      minWidth: 138
    },
    colB4: {
      minWidth: 138
    },
    colB5: {
      minWidth: 138
    },
    colB6: {
      minWidth: 100
    },
    colB7: {
      minWidth: 100
    },
    colB8: {
      minWidth: 128
    },
    cellBtn: {
      "& button": {
        fill: "currentColor",
        "& svg": {
          fill: "inherit",
          "& path": {
            fill: "inherit"
          }
        }
      }
    },
    colC1: {
      minWidth: 312
    },
    colC2: {
      minWidth: 248
    },
    colC3: {
      minWidth: 248
    },
    colC4: {
      minWidth: 420
    },
    colC5: {
      minWidth: 420
    },
    boxBackground: {
      borderRadius: 4,
      background: theme.palette.background.default,
      padding: "6px 16px",
      minHeight: 58,
      whiteSpace: "pre-line"
    },
    textConfirmDate: {
      color: theme.palette.info.dark
    },
    cellHeadCheck: {
      paddingLeft: "5px !important"
    },
    boxCancel: {
      background: theme.palette.grey[200],
      borderRadius: 4,
      width: 72,
      padding: "3px 8px",
      color: theme.palette.error.dark,
      userSelect: "none"
    },
    boxDelete: {
      background: theme.palette.grey[200],
      borderRadius: 4,
      width: 51,
      padding: "3px 8px",
      color: theme.palette.grey[900],
      userSelect: "none"
    },
    disabledLine: {
      color: theme.palette.grey[500]
    },
    wrongDate: {
      color: theme.palette.error.light
    },
    matchDate: {
      color: theme.palette.info.dark
    },

    innerTabActive: {
      WebkitClipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      width: "199px",
      height: "39px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "5px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      top: 1,
      left: 1,
      background: theme.palette.info.main,
      position: "absolute",
      borderBottom: 0,
      color: "#FFFFFF"
    },
    tableTab: {
      WebkitClipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      width: "200px",
      height: "40px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "6px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      position: "relative",
      justifyContent: "start",
      borderBottomLeftRadius: 0,
      borderBottom: 0
    },
    tableTabActive: {
      background: theme.palette.info.dark
    },
    tableTabInactive: {
      background: theme.palette.grey[400]
    },
    innerTab: {
      WebkitClipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      width: "199px",
      height: "39px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "5px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      top: 1,
      left: 1,
      background: theme.palette.grey[300],
      color: theme.palette.grey[600],
      position: "absolute",
      borderBottom: 0
    },
    zMax: {
      zIndex: 100
    }
  }),
  { name: "ItemDetailCS" }
);

export default useStyles;
